import React, { useContext } from 'react';
import { CabsLandingContext } from '../../../../CabsLandingContext';
import { getCabLandingShortCodeFromTripType } from '../../../../constants/tripTypes';
import { CardInfotype, CardType } from '../WhatsNew/WhatsNew';
import { getAppEnv } from '../../../../../config/env';
const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

export const MySafetySection = ({
  mySafetyInfo
}: {
  mySafetyInfo: CardInfotype | null;
}) => {
  const cabsLandingContext = useContext(CabsLandingContext);
  const { travelFor } = cabsLandingContext;

  const getRelevantMySafetyInfo = (): CardType | null => {
    if (mySafetyInfo?.data && mySafetyInfo?.data?.length > 0) {
      const mySafetyCards = mySafetyInfo?.data?.filter(
        (mySafetyInfoCard: CardType) => {
          return mySafetyInfoCard.trip_types.includes(
            getCabLandingShortCodeFromTripType(travelFor)
          );
        }
      );

      const mySafetyCard = mySafetyCards[0];
      return mySafetyCard;
    }
    return null;
  };

  const relevantMySafetyInfo: CardType | null = getRelevantMySafetyInfo();

  const showMySafetySection = relevantMySafetyInfo != null;
  return showMySafetySection ? (
    <div className="mySafetySection" id="mySafetySection">
      <div
        className="whiteBackGroundColor"
        style={{ padding: '15px 0px 15px 0px' }}
      >
        <div
          className="makeFlex"
          id="mySafetySectionButton"
          style={{
            padding: '10px 12px',
            margin: '0px 15px 0px 15px',
            backgroundImage:
              'linear-gradient(1.5708rad, rgb(255, 255, 255), rgb(255, 238, 237))',
            borderWidth: '1px',
            borderColor: 'rgb(212, 212, 212)',
            borderRadius: '4px',
            borderStyle: 'solid'
          }}
          onClick={() => {
            const mySafetyButton = document.getElementById(
              'mySafetySectionButton'
            );
            if (mySafetyButton) {
              mySafetyButton.style.opacity = '.5';
            }
            setTimeout(() => {
              if (mySafetyButton) {
                window.location = Object(relevantMySafetyInfo.link);
                mySafetyButton.style.opacity = '1';
              }
            }, 50);
          }}
        >
          <div>
            <img
              width={16}
              height={16}
              data-src={relevantMySafetyInfo.image}
              className="lazyload"
            />
          </div>
          <div className="makeFlex fullWidth">
            <div style={{ paddingLeft: '10px' }}>
              <div className="latoBlack lineHeight16 font14 blackText">
                {relevantMySafetyInfo.heading}
              </div>
              <div className="latoRegular lineHeight14 font12 blackText">
                {relevantMySafetyInfo.sub_heading}
              </div>
            </div>
            <div className="makeFlex perfectCenter pushRight">
              <img
                src={`${PUBLIC_URL}/static/public/right_arrow.webp`}
                alt="right_arrow"
                height={20}
                width={20}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="mySafetySection" id="mySafetySection"></div>
  );
};
